export default __webpack_public_path__ + "static/media/FrancescoVirga.6e5bc6de.png";